<ng-container *transloco="let transloco; prefix: 'uiKit'">
  <div [class]="class() || 'mb-5'">
    <ng-select
      bindLabel="name"
      bindValue="id"
      [appendTo]="'body'"
      [searchable]="false"
      [formControl]="formControl"
      [items]="items()"
      [loading]="isLoading()"
      [placeholder]="placeholder()"
      [clearable]="clearable()"
      [readonly]="disabled()"
      [loadingText]="transloco('placeholders.wait')"
      [notFoundText]="transloco('placeholders.noResults')"
      (scrollToEnd)="onScrollToEnd()"
      (change)="onChange($event)"
    >
      <ng-template ng-header-tmp>
        <div class="select-header d-flex align-items-center gap-2">
          <div
            class="search-input-wrapper position-relative d-flex align-items-center w-100"
          >
            <ui-keenicon
              name="magnifier"
              class="search-icon position-absolute text-muted"
            ></ui-keenicon>
            <input
              type="text"
              class="form-control form-control-sm"
              [placeholder]="transloco('placeholders.search')"
              [value]="searchTerm()"
              (input)="onSearchInput($event)"
              (keydown)="$event.stopPropagation()"
            />
          </div>
        </div>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        <div class="d-flex align-items-center gap-2">
          @if (item.imageUrl) {
            <img class="remote-select-image" [src]="item.imageUrl" alt="" />
          }
          <span>{{ item.name }}</span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <div class="d-flex align-items-center gap-2">
          @if (item.imageUrl) {
            <img class="remote-select-image" [src]="item.imageUrl" alt="" />
          }
          <span>{{ item.name }}</span>
        </div>
      </ng-template>
    </ng-select>
  </div>
  @if (control()['touched']) {
    <ui-validation-form [control]="control()"></ui-validation-form>
  }
  @if (description()) {
    <div class="form-text">{{ description() }}</div>
  }
</ng-container>
